var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('span',[_c('span',{staticClass:"text-trimmed"},[_vm._v(_vm._s(_vm.textTrimmed))]),_vm._v(" "),(_vm.tooLong)?_c('button',{staticClass:"slo-text-collapse-button",attrs:{"type":"button"},on:{"click":_vm.toggleTextExpand}},[_vm._v("\n    "+_vm._s(_vm._f("t")(_vm.expanded ? 'less' : 'more...'))+"\n  ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }